import { render, staticRenderFns } from "./NotificationTiltedIcon.vue?vue&type=template&id=40699c7e"
import script from "./NotificationTiltedIcon.vue?vue&type=script&lang=js"
export * from "./NotificationTiltedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports